import brandPortalAccountRoute from "@faire/web-api/routes/brand-portal/account";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
import { LiItem } from "../common/LiItem";
export var CANPayoutsIA = function CANPayoutsIA() {
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "rcTW0Q",
    defaultMessage: [{
      "type": 0,
      "value": "Pour commencer à recevoir des paiements, vous devez configurer un numéro de routage américain, qui vous permettra d'être payé en USD avec un transfert ACH. Voici la marche à suivre :"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement("ol", null, /*#__PURE__*/React.createElement(LiItem, {
    step: 1
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "HC7U/H",
    defaultMessage: [{
      "type": 0,
      "value": "Ouvrez un compte multidevises. Nous vous conseillons d'utiliser "
    }, {
      "children": [{
        "type": 0,
        "value": "OFX"
      }],
      "type": 8,
      "value": "LinkFormatting"
    }, {
      "type": 0,
      "value": "."
    }],
    values: {
      LinkFormatting: OxfLinkFormatting
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 2
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "YNvT+t",
    defaultMessage: [{
      "type": 0,
      "value": "Une fois que vous disposez d'un numéro de routage américain, accédez aux "
    }, {
      "children": [{
        "type": 0,
        "value": "Paramètres du compte"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": "."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 3
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "qfxObM",
    defaultMessage: [{
      "type": 0,
      "value": "Accédez à l'onglet "
    }, {
      "children": [{
        "type": 0,
        "value": "Paiements"
      }],
      "type": 8,
      "value": "LinkFormatting"
    }, {
      "type": 0,
      "value": "."
    }],
    values: {
      LinkFormatting: function LinkFormatting(chunks) {
        return PayoutsLinkFormatting(chunks, "payment");
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 4
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "sjxp9Z",
    defaultMessage: [{
      "type": 0,
      "value": "Ajoutez vos coordonnées bancaires, dont le nom du titulaire du compte, le numéro de routage et le numéro de compte."
    }]
  })))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "gAWP8i",
    defaultMessage: [{
      "type": 0,
      "value": "Les paiements seront ensuite émis selon le calendrier de paiement que vous avez choisi dans les paramètres de votre compte."
    }]
  })));
};
var OxfLinkFormatting = function OxfLinkFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: "https://www.ofx.com/p/faire/?pid=13968",
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var PayoutsLinkFormatting = function PayoutsLinkFormatting(chunks, tab) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalAccountRoute({
      tab: tab
    }),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};